<template>
  <v-textarea
    class="mb-2"
    :append-icon="appendIcon"
    :clearable="clearable"
    :color="color"
    :disabled="disabled"
    :hide-details="hideDetails"
    :label="label"
    :model-value="modelValue"
    :placeholder="placeholder"
    :prepend-icon="prependIcon"
    :prepend-inner-icon="prependInnerIcon"
    :readonly="readonly"
    :rules="rules"
    @update:modelValue="update"
    :variant="variant"
  >
  </v-textarea>
</template>

<script>
export default {
  props: {
    appendIcon: {
      type: String
    },
    clearable: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean
    },
    hideDetails: {
      type: Boolean
    },
    label: {
      type: String
    },
    modelValue: {
      type: String
    },
    placeholder: {
      type: String
    },
    prependIcon: {
      type: String
    },
    prependInnerIcon: {
      type: String
    },
    readonly: {
      type: Boolean
    },
    rules: {
      type: Object
    },
    type: {
      type: String,
      default: 'text'
    },
    variant: {
      type: String,
      default: 'filled'
    }
  },

  computed: {
    value () {
      return this.modelValue
    }
  },

  emits: ['update:modelValue'],

  methods: {
    update (val) {
      this.$emit('update:modelValue', val)
    }
  }
}
</script>
